const compose = require('./compose')

module.exports = function pipe (value) {
  return function (...fns) {
    return compose(...fns)(value)
  }
}
